module.exports = __webpack_public_path__ + "img/user.fe2d5af3.svg";